import { HTMLAttributes, useState } from "react";
import { OdsDateFilterDialog } from "../../../dialogs/filter-dialogs/date-filter/date-filter.dialog";
import { DateFilter, ListResult } from "../../../models";
import { ViewHelper } from "../../../services";

export interface OdsDateColumnHeaderProps {
    header: React.ReactNode;
    name: string;
    filter?: DateFilter;
    sort?: string;
    sortDirection?: string;
    onSortChanged?: (sort: string, sortDirection: string) => void;
    onFilterChanged?: (newFilter?: DateFilter) => void;
    onSearch?: (columnName: string, top: number, skip: number, filter: string) => Promise<ListResult<string>>;
}

export const OdsDateColumnHeader: React.FC<OdsDateColumnHeaderProps & HTMLAttributes<HTMLSpanElement>> = ({
    header,
    name,
    filter,
    sort,
    sortDirection,
    onSortChanged,
    onFilterChanged,
    onSearch,
    ...props
}) => {
    const [showFilter, setShowFilter] = useState<boolean>(false);

    const onFilterList = (columnName: string) => {
        setShowFilter(true);
    }

    const onDoSearch = async (top: number, skip: number, filter: string): Promise<ListResult<string>> => {
        if (onSearch) {
            return await onSearch(name, top, skip, filter);
        }
        else {
            return { totalCount: 0, items: [] };
        }
    }

    const onFilterComplete = (dialogResult: boolean, newFilter?: DateFilter) => {
        setShowFilter(false);
        if (dialogResult && onFilterChanged) {
            onFilterChanged(newFilter);
        }
    }

    const onDrawSort = (columnName: string) => {
        return ViewHelper.drawSort(columnName, sort, sortDirection, onSortChanged);
    };

    const onDrawFilter = (columnName: string, filtered: boolean) => {
        return ViewHelper.drawFilter(columnName, filtered, onFilterList, onFilterChanged);
    }

    return (
        <th>
            <OdsDateFilterDialog
                header={header}
                show={showFilter}
                filter={filter}
                onSearch={onDoSearch}
                onComplete={onFilterComplete}
            />
            <span className="ods-column-header center-column" {...props}>{header}{onDrawSort(name)}{onDrawFilter(name, !!filter)}</span>
        </th>
    )
};
